import React from 'react';

interface ConfirmationPageProps {
  referenceNumber: string;
  email: string;
}

const ConfirmationPage: React.FC<ConfirmationPageProps> = ({ referenceNumber, email }) => {
  return (
    <div className="confirmation-page">
      <div className="success-message">
        <h1>✓ Deletion Request Received</h1>
        <p>Your account deletion request has been successfully submitted.</p>
      </div>

      <div className="request-details">
        <h2>Request Details</h2>
        <dl>
          <dt>Reference Number:</dt>
          <dd>
            <strong>{referenceNumber}</strong>
          </dd>
          <dt>Email:</dt>
          <dd>{email}</dd>
          <dt>Processing Time:</dt>
          <dd>Within 30 days</dd>
        </dl>
      </div>

      <div className="next-steps">
        <h2>What Happens Next?</h2>
        <ul>
          <li>Your account has been immediately deactivated</li>
          <li>You will receive a confirmation email at {email}</li>
          <li>Your data will be deleted within 30 days</li>
          <li>You will receive a final email when deletion is complete</li>
        </ul>
      </div>

      <div className="contact-info">
        <h3>Questions or Concerns?</h3>
        <p>
          If you have any questions about your deletion request, please contact our support team:
        </p>
        <p>
          <strong>Email:</strong> privacy@xeta.net
          <br />
          <strong>Reference:</strong> {referenceNumber}
        </p>
      </div>

      <div className="notice">
        <p>
          <strong>Important:</strong> You have been logged out and will no longer be able to access
          your XETA account.
        </p>
      </div>
    </div>
  );
};

export default ConfirmationPage;
